import React from "react";
import Subscribe from "../../components/global/Subscribe";
import { Col, Row } from "reactstrap";
import { STARTER_MONTHLY_PRICE } from "../../utils/data";

const SubscribeStarter = () => {
  return (
    <>
      <Row className="w-100 h-100 m-0 api-pages">
        <Col xs="12">
          <Subscribe
            subtitle={`All Golf Courses – Starter — $${STARTER_MONTHLY_PRICE} per month`}
            price={`$${STARTER_MONTHLY_PRICE}`}
            course="All Golf Courses – Starter"
          />
        </Col>
      </Row>
    </>
  );
};

export default SubscribeStarter;
